import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';

import { TokenFormModel } from '../../views/pages/auth/models/tokenform.model';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const tform: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));

    if ((request.url.match(/.*(b1development.s3.eu-central-1.amazonaws.com).*/g) && !(request.url.includes('icibot.net')))) {
      return next.handle(request);
    } else {
      if (tform) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ` + tform.token_val,
          }
        });
      }

      return next.handle(request);
    }





  }
  // intercept(req: HttpRequest<any>, next: HttpHandler):
  //   Observable<HttpEvent<any>> {
  //   const token: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));
  //
  //   if (token) {
  //     const newReq = req.clone(
  //       {
  //         headers: req.headers.set('Authorization',
  //           'Bearer ' + token.token_val)
  //       }
  //     );
  //
  //     return next.handle(newReq).pipe(catchError(
  //       (err) => {
  //         this.authService.loggedIn = false;
  //         localStorage.removeItem('token_form');
  //         return throwError(err);
  //       }
  //     ));
  //   } else {
  //     return next.handle(req);
  //   }
  // }
}
